<script>
    export default {
        name: "FramedImageAppearanceMixin",
        data () {
            return {
                frameSizeValueToClassMap: {
                    full: "learnworlds-frame-size-full",
                    veryLarge: "learnworlds-frame-size-very-large",
                    large: "learnworlds-frame-size-large",
                    normal: "learnworlds-frame-size-normal",
                    small: "learnworlds-frame-size-small",
                    verySmall: "learnworlds-frame-size-very-small",
                },
                frameShapeValueToClassMap: {
                    rectangle: "rectangle",
                    square: "square",
                    circle: "circle"
                },
            }
        },
        mounted () {
            if (this.myData) {
                // Adding watcher on myData after myData is created.
                // If watcher is set on instantiation, it asks for myData before handleRegistration finishes.
                // At that point sectionId is not set yet, so sectionData returns an empty object.
                this.$watch('myData.responsiveFrameSizeClass', function (oldData, newData) {
                    if (typeof oldData === 'undefined' && typeof newData === 'undefined') {
                        return;
                    }
                    const responsiveFrameSizeClass = newData;
                    if (responsiveFrameSizeClass && responsiveFrameSizeClass[this.activeDevicePreview]) {
                        this.updateFrameClass(responsiveFrameSizeClass[this.activeDevicePreview]);
                    }
                }, {deep: true});
                this.$watch('myData.responsiveFrameShapeClass', function (oldData, newData) {
                    if (typeof oldData === 'undefined' && typeof newData === 'undefined') {
                        return;
                    }
                    const responsiveFrameShapeClass = newData;
                    if (responsiveFrameShapeClass && responsiveFrameShapeClass[this.activeDevicePreview]) {
                        this.updateFrameClass(false, responsiveFrameShapeClass[this.activeDevicePreview]);
                    }
                }, {deep: true});
            }
            // push responsive functions to nodeState
            this.responsiveFunctions.push('updateFrameClassForDevice');
        },
        methods: {
            getFrameSize () {
                return this.getKeyForMatchingClass(this.frameSizeValueToClassMap, {defaultValue: "normal"});
            },
            getFrameShape () {
                return this.getKeyForMatchingClass(this.frameShapeValueToClassMap, {defaultValue: "square"});
            },
            getFrameOpacity () {
                return this.getStyleProperty("opacity", {defaultValue: 1, parse: "float"});
            },
            setFrameOpacity (eventData) {
                this.applyStyle({styleProp: "opacity", value: eventData.value})
            },
            setFrameSize (data) {
                let responsiveFrameSizeClass = this.myData.responsiveFrameSizeClass;
                if (!responsiveFrameSizeClass['desktop']) {
                    responsiveFrameSizeClass['desktop'] = this.frameSizeValueToClassMap[this.getFrameSize()];
                }
                responsiveFrameSizeClass[this.activeDevicePreview] = this.frameSizeValueToClassMap[data.value];
                this.changeMyData({responsiveFrameSizeClass});

            },
            setFrameShape (data) {
                let responsiveFrameShapeClass = this.myData.responsiveFrameShapeClass;
                if (!responsiveFrameShapeClass['desktop']) {
                    responsiveFrameShapeClass['desktop'] = this.frameShapeValueToClassMap[this.getFrameShape()];
                }
                responsiveFrameShapeClass[this.activeDevicePreview] = this.frameShapeValueToClassMap[data.value];
                this.changeMyData({responsiveFrameShapeClass});
            },
            updateFrameClassForDevice (device, node) {
                const responsiveFrameSizeClass = this.myData.responsiveFrameSizeClass;
                const responsiveFrameShapeClass = this.myData.responsiveFrameShapeClass;
                let frameSizeClass = false;
                let frameShapeClass = false;

                if (responsiveFrameSizeClass) {
                    if (responsiveFrameSizeClass[device]) {
                        frameSizeClass = responsiveFrameSizeClass[device];
                    } else if (responsiveFrameSizeClass['desktop']) {
                        frameSizeClass = responsiveFrameSizeClass['desktop'];
                    }
                }
                if (responsiveFrameShapeClass) {
                    if (responsiveFrameShapeClass[device]) {
                        frameShapeClass = responsiveFrameShapeClass[device];
                    } else if (responsiveFrameShapeClass['desktop']) {
                        frameShapeClass = responsiveFrameShapeClass['desktop'];
                    }
                }
                if (frameSizeClass || frameShapeClass) {
                    this.updateFrameClass(frameSizeClass, frameShapeClass, node)
                }
            },
            updateFrameClass (frameSizeClass, frameShapeClass, node) {
                if (frameSizeClass) {
                    let params = {
                        newClass: frameSizeClass,
                        classesToRemove: this.getMappedClasses(this.frameSizeValueToClassMap)
                    };
                    this.applyClass(params, node);
                }
                if (frameShapeClass) {
                    let params = {
                        newClass: frameShapeClass,
                        classesToRemove: this.getMappedClasses(this.frameShapeValueToClassMap)
                    };
                    this.applyClass(params, node);
                }
            },
        },
        watch: {
            activeDevicePreview: {
                handler () {
                    this.updateFrameClassForDevice(this.activeDevicePreview);
                }
            }
        },
    }
</script>
